// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__hoeTb","footer":"Form_footer__3X1Ow"};